export const SomethingWentWrong = 'Something went wrong';
